import React, { Fragment } from 'react';
import { getIconOrFlag } from "./getIconOrFlag";
import { getDiallingCode } from "./getDiallingCode";
var optionCache = {};
export var getAllOptions = function getAllOptions(options) {
  return options.map(function (_ref) {
    var value = _ref.value,
        label = _ref.label;

    if (!optionCache[label]) {
      var iconOrFlag = getIconOrFlag(value);
      optionCache[label] = {
        name: label,
        text: iconOrFlag,
        value: value,
        content: React.createElement(Fragment, null, iconOrFlag, "".concat(label, " ").concat(getDiallingCode(value)))
      };
    }

    return optionCache[label];
  });
};